import(/* webpackMode: "eager", webpackExports: ["BrandSpinner"] */ "/opt/buildhome/repo/src/shared/ui/brand-spinner.tsx");
